<template>
  <div>
    <div class="modal-header">
      <h2>Upozorenje</h2>
    </div>
    <div class="modal-body">
      <p>
        Da li ste sigurni da želite da uklonite korisnika kao upravnika
        zajednice:
      </p>
      <p class="filename">
        {{ managerCommunity.address }} {{ managerCommunity.street_number }},
        {{ managerCommunity.city }}
      </p>
    </div>
    <hr />
    <div class="footer">
      <button type="submit" class="btn btn-danger btn--mod" @click="closeModal">
        Otkaži
      </button>
      <button
        type="submit"
        class="btn btn-primary btn--mod"
        @click="removeManagerCommunity"
        :disabled="loading"
      >
        <span v-if="!loading">Potvrdi</span>
        <spinner line-fg-color="#00796b" v-if="loading" />
      </button>
    </div>
  </div>
</template>

<script>
import axios from '@/axios/axios.js';
import { mapState, mapMutations, mapActions } from 'vuex';
export default {
  computed: {
    ...mapState('modal', ['managerCommunity', 'manager']),
    ...mapState(['loading'])
  },
  methods: {
    ...mapMutations(['loadingStarted', 'loadingFinished']),
    ...mapMutations('modal', ['closeModal', 'showModal']),
    ...mapActions('modal', ['showSuccessModal', 'showFailModal']),
    ...mapActions('table', ['getAllContractors']),
    removeManagerCommunity() {
      if (this.loading) {
        return;
      }
      this.loadingStarted();
      const data = {
        community_id: this.managerCommunity.id,
        member_id: this.managerCommunity.member_id
      };
      axios
        .post('member/remove', data)
        .then(async () => {
          this.manager.communities = this.manager.communities.filter(
            c => c.id != this.managerCommunity.id
          );
          this.loadingFinished();
          this.closeModal();
          this.showSuccessModal();
        })
        .catch(e => {
          console.log('eer', e);
          this.loadingFinished();
          this.showFailModal();
        });
    }
  }
};
</script>

<style scoped>
.filename {
  word-break: break-word;
}
</style>
